import ClientInfo from './client-info';

export default ClientInfo;
